/**
 * Created by neo on 02.12.20.
 *
 * Plain TypeScript type - no MobX observables.
 */
import { WeekDayEntryBase, parseWeekDayEntry } from './WeekDayEntry';
import { MicroCycleDay, createMicroCycleDay } from '../Program/MicroCycleDay';

export type WeekDayEntryWorkout = WeekDayEntryBase & {
  type: 'workout';
  workout: MicroCycleDay;
};

export function parseWeekDayEntryWorkout(json?: any): WeekDayEntryWorkout {
  return {
    ...parseWeekDayEntry({ ...json, type: 'workout' }),
    type: 'workout' as const,
    workout: createMicroCycleDay(json?.workout),
  };
}

/** @deprecated Use parseWeekDayEntryWorkout instead */
export const createWeekDayEntryWorkout = parseWeekDayEntryWorkout;
